
function AboutScottPage() {
  return (
    <main className="bg-white py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Page Title */}
        <h1 
          className="text-5xl font-bold text-center mb-16 text-black" 
          style={{ fontFamily: 'Poppins, sans-serif' }}
        >
          About Scott
        </h1>

        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20">
          {/* Left Column - Scott's Image */}
          <div className="flex justify-center">
            <div className="w-full max-w-lg">
              <img
                src="//img1.wsimg.com/isteam/ip/825d56ba-0d92-4fe9-9887-df9195c758ea/blob-e2a6049.png/:/cr=t:3.41%25,l:0%25,w:100%25,h:93.12%25/rs=w:600,h:800,cg:true"
                alt="Scott Higginbotham"
                className="w-full border-6 border-indigo-900"
              />
            </div>
          </div>

          {/* Right Column - Scott's Background */}
          <div className="flex flex-col justify-center">
            <h2 
              className="text-3xl font-bold mb-6 text-gray-800" 
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              My Background
            </h2>
            <div className="text-gray-800 space-y-6 text-lg">
              <p>
                Scott is a lifelong Conservative Republican and small business owner who has called League City 
                home for the past 14 years. He's a graduate of Lipscomb University with degrees in Finance, 
                Economics and Management. Scott currently serves on the League City Planning &amp; Zoning Commission, 
                Capital Improvement Advisory Committee, and formerly served as a member of the League City Ethics Review Board.
              </p>
              <p>
                He and his wife Kristy have 2 kids and are actively involved in the community. Scott has spent the 
                past several years and countless hours serving as a youth sports coach in football, baseball, and 
                soccer while also serving on the PTA and being named as a past ARC of the Gulf Coast Volunteer of the Year. 
                His wife Kristy is currently PTA President of Clear Creek Intermediate and the Ferguson Elementary PTA 
                Parliamentarian, along with numerous other past roles such as Carnival Chair.
              </p>
              <p>
                Both Scott &amp; Kristy are active members in their church, League City Church of Christ where they've 
                taught Bible classes, helped with VBS, and worked on storm clean-up efforts in the community. Scott and 
                his family enjoy spending time outdoors, boating, and all things sports.
              </p>
            </div>
          </div>
        </div>

        {/* Issues Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mt-12">
          {/* Left Column - The Issues (was originally on right) */}
          <div className="flex flex-col justify-center order-1 lg:order-1">
            <h2 
              className="text-3xl font-bold mb-6 text-gray-800 uppercase" 
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              The Issues
            </h2>
            <div className="text-gray-800 space-y-8 text-lg">
              <div>
                <h3 className="text-2xl font-bold text-indigo-900 mb-3">LOWER TAXES</h3>
                <p>
                  As your councilman, Scott will fight to lower tax rates and control spending to ensure that 
                  League City residents and business owners aren't burdened by ever increasing property taxes. 
                  Scott will NEVER vote to raise taxes.
                </p>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-indigo-900 mb-3">PUBLIC SAFETY</h3>
                <p>
                  We need a councilman who will support our first responders and make sure League City continues 
                  maintaining its status as one of the safest cities to live and raise a family in Texas.
                </p>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-indigo-900 mb-3">INFRASTRUCTURE</h3>
                <p>
                  Water, drainage, and traffic infrastructure improvements are critical to League City's growth. 
                  Scott will make sure that the council is properly preparing for the future while taking care 
                  of our current residents and needs.
                </p>
              </div>
            </div>
          </div>

          {/* Right Column - Image (was originally on left) */}
          <div className="flex justify-center items-center order-2 lg:order-2">
            <div className="w-96 h-96 lg:w-112 lg:h-112 mx-auto">
              <img
                src="//img1.wsimg.com/isteam/ip/825d56ba-0d92-4fe9-9887-df9195c758ea/1664789358790.jpg/:/rs=w:600,h:600,cg:true,m/cr=w:600,h:600"
                alt="Scott Higginbotham"
                className="w-full h-full object-cover rounded-full border-4 border-indigo-900 shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default AboutScottPage;